<template>
    <div v-if="data" class="container" >
        <title-area :title="data?.headTitle" />
        <div class="row">
            <div class="col-lg-6 text-center ">
                <img 
                    v-if="data?.img" 
                    :src="require(`@/assets/KompetencatTerritoriale/${data.img}`)" 
                    width="80%"
                    class="drop-shadow"/>
            </div>
            <div class="col-lg-6 d-flex flex-column justify-content-center">
                <div class="shadow p-3 mb-5 bg-white rounded">
                     <h5>
                        <title-area :title="data?.title" />
                    </h5>
                    <p v-if="data?.content" v-html="data.content" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TitleArea from '@/components/share/TitleArea.vue';

export default {
    data() {
        return {
            data: '',
            subdomain: '',
        }
    },
    components: {
        TitleArea
    },
    methods: {
        getSubdomain() {
            const host = window.location.hostname; // p.sh. "kpk.localhost"
            this.subdomain = ''; // Default subdomain
            if (host.includes('.')) {
                this.subdomain = host.split('.')[0];
            }
        },
        getDataForSubdomain(sub) {
            const allData = {
                pa: {
                     headTitle: this.$te("menus.pa.competencies.head_title") ? this.$t("menus.pa.competencies.head_title") : null, 
                     img:this.$te("menus.pa.competencies.img") ? this.$t("menus.pa.competencies.img") : null,
                     title:this.$te("menus.pa.competencies.title") ? this.$t("menus.pa.competencies.title") : null, 
                     content:this.$te("menus.pa.competencies.content") ? this.$t("menus.pa.competencies.content") : null
                },
                ps:{
                    headTitle: this.$te("menus.ps.competencies.head_title") ? this.$t("menus.ps.competencies.head_title") : null, 
                    img:this.$te("menus.ps.competencies.img") ? this.$t("menus.ps.competencies.img") : null,
                    title:this.$te("menus.ps.competencies.title") ? this.$t("menus.ps.competencies.title") : null, 
                    content:this.$te("menus.ps.competencies.content") ? this.$t("menus.ps.competencies.content") : null
                },
                pthprishtine: {
                    headTitle: this.$te("menus.pthprishtine.competencies.head_title") ? this.$t("menus.pthprishtine.competencies.head_title") : null, 
                    img:this.$te("menus.pthprishtine.competencies.img") ? this.$t("menus.pthprishtine.competencies.img") : null,
                    title:this.$te("menus.pthprishtine.competencies.title") ? this.$t("menus.pthprishtine.competencies.title") : null, 
                    content:this.$te("menus.pthprishtine.competencies.content") ? this.$t("menus.pthprishtine.competencies.content") : null
                },
                pthprizren: {
                    headTitle: this.$te("menus.pthprizren.competencies.head_title") ? this.$t("menus.pthprizren.competencies.head_title") : null, 
                    img:this.$te("menus.pthprizren.competencies.img") ? this.$t("menus.pthprizren.competencies.img") : null,
                    title:this.$te("menus.pthprizren.competencies.title") ? this.$t("menus.pthprizren.competencies.title") : null, 
                    content:this.$te("menus.pthprizren.competencies.content") ? this.$t("menus.pthprizren.competencies.content") : null
                },
                pthferizaj: {
                    headTitle: this.$te("menus.pthferizaj.competencies.head_title") ? this.$t("menus.pthferizaj.competencies.head_title") : null, 
                    img:this.$te("menus.pthferizaj.competencies.img") ? this.$t("menus.pthferizaj.competencies.img") : null,
                    title:this.$te("menus.pthferizaj.competencies.title") ? this.$t("menus.pthferizaj.competencies.title") : null, 
                    content:this.$te("menus.pthferizaj.competencies.content") ? this.$t("menus.pthferizaj.competencies.content") : null
                },
                pthpeje: {
                    headTitle: this.$te("menus.pthpeje.competencies.head_title") ? this.$t("menus.pthpeje.competencies.head_title") : null, 
                    img:this.$te("menus.pthpeje.competencies.img") ? this.$t("menus.pthpeje.competencies.img") : null,
                    title:this.$te("menus.pthpeje.competencies.title") ? this.$t("menus.pthpeje.competencies.title") : null, 
                    content:this.$te("menus.pthpeje.competencies.content") ? this.$t("menus.pthpeje.competencies.content") : null
                },
                pthmitrovice: {
                    headTitle: this.$te("menus.pthmitrovice.competencies.head_title") ? this.$t("menus.pthmitrovice.competencies.head_title") : null, 
                    img:this.$te("menus.pthmitrovice.competencies.img") ? this.$t("menus.pthmitrovice.competencies.img") : null,
                    title:this.$te("menus.pthmitrovice.competencies.title") ? this.$t("menus.pthmitrovice.competencies.title") : null, 
                    content:this.$te("menus.pthmitrovice.competencies.content") ? this.$t("menus.pthmitrovice.competencies.content") : null
                },
                pthgjilan: {
                    headTitle: this.$te("menus.pthgjilan.competencies.head_title") ? this.$t("menus.pthgjilan.competencies.head_title") : null, 
                    img:this.$te("menus.pthgjilan.competencies.img") ? this.$t("menus.pthgjilan.competencies.img") : null,
                    title:this.$te("menus.pthgjilan.competencies.title") ? this.$t("menus.pthgjilan.competencies.title") : null, 
                    content:this.$te("menus.pthgjilan.competencies.content") ? this.$t("menus.pthgjilan.competencies.content") : null
                },
                pthgjakove:{
                    headTitle: this.$te("menus.pthgjakove.competencies.head_title") ? this.$t("menus.pthgjakove.competencies.head_title") : null, 
                    img:this.$te("menus.pthgjakove.competencies.img") ? this.$t("menus.pthgjakove.competencies.img") : null,
                    title:this.$te("menus.pthgjakove.competencies.title") ? this.$t("menus.pthgjakove.competencies.title") : null, 
                    content:this.$te("menus.pthgjakove.competencies.content") ? this.$t("menus.pthgjakove.competencies.content") : null
                }
            }

            return allData[sub] || allData.default
        }
    },

    mounted() {
        this.getSubdomain();
        if (this.subdomain) {
            this.data = this.getDataForSubdomain(this.subdomain);
            } else {
                console.log("Subdomain është i zbrazët.");
            }
        },
}
</script>
<style scoped>

img.drop-shadow {
	filter: drop-shadow(5px 2px 5px rgba(48, 17, 17, 0.664));
}

</style>